import { Alert, styled } from '@mui/material';
import { Typography } from '@mui/material';

const AlertContainer = styled(Alert)({
  paddingTop: 0,
  paddingBottom: 0,
});
const Icon = styled('img')({
  width: '16px',
  height: '16px',
  margin: 'auto',
});
const Text = styled(Typography)({
  fontSize: '12px',
});

interface InsuranceSelectedAlertProps {
  coverage: number;
}
export const InsuranceSelectedAlert = ({
  coverage,
}: InsuranceSelectedAlertProps) => {
  return (
    <AlertContainer
      severity="success"
      icon={<Icon src={'/assets/images/okIcon.svg'} />}
    >
      {coverage > 0 ? (
        <Text>Seguro aplicado exitosamente</Text>
      ) : (
        <Text>
          El seguro fue aplicado correctamente, pero los productos de tu carrito
          no son reembolsables.
        </Text>
      )}
    </AlertContainer>
  );
};
